import React from 'react';
import { 
    Box, 
    FormControl, 
    Grid, 
    TextField, 
    Typography,
    FormHelperText
} from '@mui/material';
import '../ShippingAddressComponent/ShippingAddressComponent.css';
import {getBookdetails} from '../../store/actions/book.js';
import { connect } from "react-redux";
import { useImmer } from 'use-immer';

const ShippingAddressComponent = ({

    bookDetails,
    getuserBookdetails,
    setuserBookdetails

}) => {

     const [BookID, setBookID] = useImmer('');
     const [MailPersonPinCodeError , setMailPersonPinCodeError] = useImmer(false);

    
        React.useEffect(() => {
            setBookID(bookDetails.BookID);
    
        }, [bookDetails])

        React.useEffect(() => {
            if (!getuserBookdetails.bookUserAlt) {
                setuserBookdetails((draft) => {
                    draft.bookUserAlt = { value: "", isValid: true, errorMessage: "" };
                });
            }
        }, []);

        console.log(bookDetails);

    const handlePersonName = (event) => {
        let data = event.target.value;
    
        // Trim leading spaces and allow Unicode letters, numbers, spaces, parentheses, and combining marks
        data = data
            .trimStart()
            .replace(/[^\p{L}\p{N}\p{M} ()]/gu, ""); // Include combining marks
    
        setuserBookdetails((draft) => {
            draft.bookUserName.value = data;
            draft.bookUserName.isValid = data.trim() ? true : false; // Prevent spaces-only inputs
        });
    };

    const handlePersonAddress = (event) => {
        const value = event.target.value.trimStart(); // Remove leading spaces only
    
        setuserBookdetails((draft) => {
            draft.bookUserAddress.value = value;
            draft.bookUserAddress.isValid = value.length > 0; // Ensure field is not empty
        });
    };
    

    
    
const handlePersonPinCode = (event) => {
  const pincode = event.target.value.trim();
  const numericPinRegex = /^[1-9]\d{5}$/; // standard Indian 6-digit pincode
  const isNumeric = /^[0-9]+$/.test(pincode);

  setuserBookdetails((draft) => {
    draft.bookUserPincode.value = pincode;

    if (!isNumeric) {
      draft.bookUserPincode.isValid = false;
      draft.bookUserPincode.errorMessage = "Please enter a valid Pincode";
    }  else if (!numericPinRegex.test(pincode)) {
      draft.bookUserPincode.isValid = false;
      draft.bookUserPincode.errorMessage = "We are not shipping outside India";
    } else {
      draft.bookUserPincode.isValid = true;
      draft.bookUserPincode.errorMessage = "";
    }
  });
};

    const handlePersonContactNumber = (event) => {
        let contactNumber = event.target.value.replace(/[^0-9]/g, ''); // Only digits

        // Restrict to max 10 digits
        if (contactNumber.length > 10) {
            contactNumber = contactNumber.slice(0, 10);
        }

        setuserBookdetails((draft) => {
            draft.bookUserContact.value = contactNumber;

            // Validation: must be exactly 10 digits and not all zeros
            const isValid = contactNumber.length === 10 && contactNumber !== "0".repeat(10);
            draft.bookUserContact.isValid = isValid;
            draft.bookUserContact.errorMessage = isValid ? "" : "Enter a valid mobile number";

            // Ensure bookUserAlt exists (falls back safely if the store hasn't been updated with it)
            if (!draft.bookUserAlt) {
                draft.bookUserAlt = { value: "", isValid: true, errorMessage: "" };
            }

            // Cross-check against Alternate Number (mirrors DevoteeDetailsComponent)
            if (
                contactNumber.length === 10 &&
                draft.bookUserAlt.value.length === 10 &&
                contactNumber === draft.bookUserAlt.value
            ) {
                draft.bookUserAlt.isValid = false;
                draft.bookUserAlt.errorMessage = "Contact Number and Alternate Number should not be the same";
            } else if (
                draft.bookUserAlt.value.length === 10 &&
                contactNumber !== draft.bookUserAlt.value
            ) {
                draft.bookUserAlt.isValid = true;
                draft.bookUserAlt.errorMessage = "";
            }
        });
    };

    const handlePersonAltNumber = (event) => {
        let alternateNumber = event.target.value.replace(/[^0-9]/g, ''); // Only digits

        // Restrict to max 10 digits
        if (alternateNumber.length > 10) {
            alternateNumber = alternateNumber.slice(0, 10);
        }

        setuserBookdetails((draft) => {
            if (!draft.bookUserAlt) {
                draft.bookUserAlt = { value: "", isValid: true, errorMessage: "" };
            }
            draft.bookUserAlt.value = alternateNumber;

            if (alternateNumber === "" || /^0+$/.test(alternateNumber)) {
                // Optional field: empty is fine, but all-zeros is not
                draft.bookUserAlt.isValid = alternateNumber === "";
                draft.bookUserAlt.errorMessage = alternateNumber === "" ? "" : "Enter a valid mobile number";
            } else if (alternateNumber.length < 10) {
                draft.bookUserAlt.isValid = false;
                draft.bookUserAlt.errorMessage = "Enter a valid mobile number";
            } else if (alternateNumber === draft.bookUserContact.value) {
                draft.bookUserAlt.isValid = false;
                draft.bookUserAlt.errorMessage = "Contact Number and Alternate Number should not be the same";
            } else {
                draft.bookUserAlt.isValid = true;
                draft.bookUserAlt.errorMessage = "";
            }
        });
    };

     const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const handlebookEmail = (event) => {
      const email = event.target.value.trim().toLowerCase();
    
      setuserBookdetails((draft) => {
        draft.bookUserEmail.value = email;
    
        if (emailRegex.test(email)) {
          draft.bookUserEmail.isValid = true; // Mark as valid
          draft.bookUserEmail.error = ""; // Clear error message
        } else {
          draft.bookUserEmail.isValid = false; // Mark as invalid
          draft.bookUserEmail.error = "Invalid email format"; // Set error message
        }
      });
    };

       const handlebookComments = (event) => {
        const Comments = event.target.value;
        setuserBookdetails((draft) => {
            draft.bookUserComments.value = Comments;
            // Validate only if comments exceed 120 characters
            draft.bookUserComments.isValid = Comments.length <= 120;
          });
    }

   const HandlePan = (event) => {
    const Pan = event.target.value.trim().toUpperCase();
    const regpan = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    setuserBookdetails((draft) => {
        draft.userPanNo.value = Pan;
        draft.userPanNo.isValid = Pan === "" || regpan.test(Pan); // valid if empty or matches regex
        draft.userPanNo.errorMessage = Pan !== "" && !regpan.test(Pan) ? "Please enter a valid PAN number" : "";
    });
}
    
  return (
    <>
        <Box
            className='get-books-orders'
            component="form"
            sx={{
            '& .MuiTextField-root': { m: 1 },
            mx: 20,
            pt: 6
            }}
            noValidate
            autoComplete="off"
        >
            <div>
                        <Box className="form-control-spacing">
                            <Typography sx={{ pb: 4, fontWeight: '600', color: '#010101' }}>Enter address where books have to be couriered.
                            <Typography sx={{ mt: 2, color: 'red', fontSize: '0.9rem' }}>
                            Shipping is currently available within India only.
                            </Typography>

                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Box>
                                        <label>Name <span className="label-required">*</span></label>
                                    </Box>
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <FormControl fullWidth>
                                        <TextField id="outlined-basic"
                                        variant="outlined" 
                                        value={getuserBookdetails.bookUserName.value} 
                                        onChange={handlePersonName} 
                                        />
                                    </FormControl>
                                    {getuserBookdetails.bookUserName.value == "" && (
                                        <FormHelperText error> 
                                            Please enter a valid Name
                                        </FormHelperText>
                                        )}
                                </Grid>
                            </Grid>
                        </Box>
                            <Box className="form-control-spacing">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box>
                                            <label>Address <span className="label-required">*</span></label>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth>
                                            <TextField multiline
                                            rows = '4'
                                            id="outlined-basic" 
                                            variant="outlined"  
                                            value={getuserBookdetails.bookUserAddress.value} 
                                            onChange={handlePersonAddress}  
                                            />
                                        </FormControl>
                                        {!getuserBookdetails.bookUserAddress.isValid && (
                                            <FormHelperText error>
                                                Please enter a valid Address
                                            </FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    <Grid item xs={12} sm={4}>
                                        <Box>
                                            <label>Country <span className="label-required"></span></label>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth>
                                            <TextField
                                                id="outlined-country"
                                                variant="outlined"
                                                value="India"
                                                disabled
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box className="form-control-spacing">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box>
                                            <label>Pin Code <span className="label-required">*</span></label>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth>
                                            <TextField id="outlined-basic"
                                            variant="outlined" 
                                            type="text" 
                                            value={getuserBookdetails.bookUserPincode.value} 
                                            onChange={handlePersonPinCode} 
                                            error = {MailPersonPinCodeError} 
                                            />
                                        </FormControl>
                                            {!getuserBookdetails.bookUserPincode.isValid && (
                                        <FormHelperText error>
                                            {getuserBookdetails.bookUserPincode.errorMessage}
                                            </FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box className="form-control-spacing">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box>
                                            <label>Mobile <span className="label-required">*</span></label>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth>
                                            <TextField id="outlined-basic"
                                            variant="outlined"
                                            type="text"
                                            inputMode="numeric"
                                            value={getuserBookdetails.bookUserContact.value}
                                            onChange={handlePersonContactNumber}
                                            />
                                        </FormControl>
                                        {!getuserBookdetails.bookUserContact.isValid && (
                                        <FormHelperText error>
                                        {getuserBookdetails.bookUserContact.errorMessage || "Please enter a valid Contact number"}
                                    </FormHelperText>
                                        )}                            
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box className="form-control-spacing">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={4}>
                                        <Box>
                                            <label>Alternate Mobile No#</label>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={8}>
                                        <FormControl fullWidth>
                                            <TextField id="outlined-basic"
                                            variant="outlined"
                                            type="text"
                                            inputMode="numeric"
                                            value={getuserBookdetails.bookUserAlt?.value ?? ""}
                                            onChange={handlePersonAltNumber}
                                            />
                                        </FormControl>
                                        {getuserBookdetails.bookUserAlt && !getuserBookdetails.bookUserAlt.isValid && (
                                        <FormHelperText error>
                                        {getuserBookdetails.bookUserAlt.errorMessage}
                                        </FormHelperText>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>

                                <Box sx={{ mb: 4 }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={4}>
                                            <Box>
                                                <label>Your Email ID <span className='label-required'>*</span></label>
                                            </Box>
                                        </Grid>
                                        <Grid item xs={12} sm={8}>
                                            <FormControl fullWidth>
                                                <TextField 
                                                id="outlined-basic" 
                                                variant="outlined" 
                                                value = {getuserBookdetails.bookUserEmail.value} 
                                                onChange={handlebookEmail} 
                                                />
                                                 {!getuserBookdetails.bookUserEmail.isValid && (
                                                 <FormHelperText error>
                                                 {getuserBookdetails.bookUserEmail.errorMessage}
                                                 </FormHelperText>
                                                )}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Box>
                        
                             <Box sx={{ mb: 4 }}>
                                                    <Grid container spacing={2}>
                                                       <Grid item xs={12} sm={4}>
                                                            <Box>
                                                             <label>Your PAN <span className='label-required'></span></label>                 
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={8}>
                                                          <FormControl fullWidth>
                                                    <TextField
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        value={getuserBookdetails.userPanNo.value}
                                                        onChange={HandlePan}
                                                        inputProps={{ maxLength: 10 }}
                                                        error={getuserBookdetails.userPanNo.value !== "" && !getuserBookdetails.userPanNo.isValid}
                                                    />
                                                    {getuserBookdetails.userPanNo.value !== "" && !getuserBookdetails.userPanNo.isValid && (
                                                        <FormHelperText error>
                                                            {getuserBookdetails.userPanNo.errorMessage}
                                                        </FormHelperText>
                                                    )}
                                                </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                 <Box sx={{ mb: 4 }}>
                                    <Grid container spacing={2}>
                                                        <Grid item xs={12} sm={4}>
                                                            <Box>
                                                                <label>Delivery Instructions </label>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm={8}>
                                                            <FormControl fullWidth>
                                                                <TextField
                                                                    id="outlined-multiline-flexible"
                                                                    multiline
                                                                    rows={4}
                                                                    value={getuserBookdetails.bookUserComments.value}
                                                                    onChange={handlebookComments}
                                                                    error = {!getuserBookdetails.bookUserComments.isValid}
                                                                />
                                                                <span>{getuserBookdetails.bookUserComments.value.length}/120</span>
                                                                {
                                                                !getuserBookdetails.bookUserComments.isValid && (
                                                                <FormHelperText error>
                                                                {getuserBookdetails.bookUserComments.errorMessage}
                                                                </FormHelperText>
                                                                )
                                                                }
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                        </div>
                    </Box>
                </>
            )
}

const mapStateToProps = (state) => {
    return {
        bookDetails : state.book.bookDetails
    };
}

export default connect(mapStateToProps,{
    getBookdetails
    
  })(ShippingAddressComponent);